import { useEffect, useState } from "react";
import api from "../lib/api";
import { logger } from "../lib/logger";
import { HomeHero } from "../components/home/HomeHero";
import { TrustBar } from "../components/home/TrustBar";
import { FeaturedArtSection } from "../components/home/FeaturedArtSection";
import { PriceTiersSection } from "../components/home/PriceTiersSection";
import { FeaturedArtistsSection } from "../components/home/FeaturedArtistsSection";
import { CategoriesSection } from "../components/home/CategoriesSection";
import { SellYourArtSection } from "../components/home/SellYourArtSection";
import { TestimonialsSection } from "../components/home/TestimonialsSection";
import { ArtistOfWeekSection } from "../components/home/ArtistOfWeekSection";
import { InstagramSection } from "../components/home/InstagramSection";
import { NewsletterSection } from "../components/home/NewsletterSection";
import { IntroVideosSection } from "../components/home/IntroVideosSection";
import Seo, { organizationLd } from "../components/Seo";

export default function Home() {
  const [featured, setFeatured] = useState([]);
  const [artists, setArtists] = useState([]);
  const [introVideos, setIntroVideos] = useState([]);

  const loadIntroVideos = () =>
    api
      .get("/intro-videos", { params: { limit: 4 } })
      .then(({ data }) => setIntroVideos(data || []))
      .catch(() => {});

  useEffect(() => {
    (async () => {
      try {
        const [a, b, c] = await Promise.all([
          api.get("/artworks/featured"),
          api.get("/artists/featured"),
          api.get("/intro-videos", { params: { limit: 4 } }),
        ]);
        setFeatured(a.data);
        setArtists(b.data.slice(0, 4));
        setIntroVideos(c.data || []);
      } catch (err) {
        logger.error("Home featured/artists load failed:", err);
      }
    })();
  }, []);

  return (
    <div data-testid="home-page">
      <Seo
        title="African Art for Sale — Original African Sculptures & Paintings"
        description="Buy original African art direct from contemporary masters. African paintings, sculptures, photography and mixed-media works for sale — curated from Harare, Johannesburg, Lusaka and beyond on AfricaArtMasters."
        path="/"
        jsonLd={organizationLd()}
      />
      <HomeHero />
      <TrustBar />
      <FeaturedArtSection featured={featured} />
      <IntroVideosSection items={introVideos} onChanged={loadIntroVideos} />
      <ArtistOfWeekSection />
      <PriceTiersSection />
      <FeaturedArtistsSection artists={artists} />
      <CategoriesSection />
      <SellYourArtSection />
      <TestimonialsSection />
      <InstagramSection tiles={featured} />
      <NewsletterSection />
    </div>
  );
}
